import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@radix-ui/react-dropdown-menu";
import { useEffect, useState } from "react";
import Loading from "@/shared/common/Loading";
import { Button } from "@/components/ui/button";
import { getViewName, newAddColumnsViews, updateViewName } from "@/store/actions/ColumnsViewsActine";
import { useDispatch } from "react-redux";

const AddViewModal = (props) => {
     const { show, onHide, sectionType, fetchId } = props;
     const dispatch = useDispatch();
     const [viewName, setViewName] = useState('')
     const [isLoading, setIsLoading] = useState(false)

     useEffect(() => {
          if (show) {
               if (fetchId !== null) {
                    dispatch(getViewName(fetchId, setIsLoading)).then((res) => {
                         setViewName(res?.data?.name)
                    })
               } else {
                    setViewName('')
               }
          }
     }, [show, fetchId])

     const handleCreateView = () => {
          if (fetchId) {
               dispatch(updateViewName(fetchId, viewName, setIsLoading, onHide, sectionType))
          }
          else {
               const transformedData = {
                    name: viewName,
                    section: sectionType,
                    columns: [],
               };
               dispatch(newAddColumnsViews(sectionType, transformedData, setIsLoading, onHide))
          }
     }

     return (
          <Dialog open={show} onOpenChange={onHide}>
               <DialogContent>
                    <DialogHeader>
                         <DialogTitle className="text-center">Add Views</DialogTitle>
                    </DialogHeader>
                    {isLoading ? <div className="flex justify-center items-center h-[8vh]"> <Loading /> </div> :
                         <div className="">
                              <Label className="text-sm text-textV1 mb-1">View Name <span className="text-red">*</span></Label>
                              <Input type='text' placeholder={'Enter View Name'} className={'w-[100%]'} name='name' value={viewName} onChange={(e) => setViewName(e.target.value)} />
                         </div>
                    }
                    <DialogFooter>
                         <Button variant="outline" onClick={onHide}>
                              Cancel
                         </Button>
                         <Button onClick={handleCreateView} disabled={isLoading || !viewName}>{isLoading && <Loading height={20} width={20} color={'#fff'} />} {fetchId ? 'Edit View' : 'Add View'}</Button>
                    </DialogFooter>
               </DialogContent>
          </Dialog>
     )
}

export default AddViewModal; 